"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productMutations = exports.productMutationKeys = void 0;
const product_api_1 = require("./product.api");
exports.productMutationKeys = {
    all: () => ['product'],
    postNotifyMeSubscribe: () => [...exports.productMutationKeys.all(), 'postNotifyMeSubscribe'],
};
const productMutations = (apiOptions) => ({
    postNotifyMeSubscribe: {
        mutationKey: exports.productMutationKeys.postNotifyMeSubscribe(),
        mutationFn: (params) => (0, product_api_1.postNotifyMeSubscribe)(apiOptions, params),
    },
});
exports.productMutations = productMutations;
//# sourceMappingURL=product.mutations.js.map